import type {ActionSpec, ActionStruct} from '@cohort/shared/apps/app';
import {z} from 'zod';

export const GetContactListInputSchema = z.object({
  listId: z.number(),
});
export type GetContactListInput = z.infer<typeof GetContactListInputSchema>;

export const GetContactListOutputSchema = z.object({
  id: z.number(),
  name: z.string(),
  totalBlacklisted: z.number().optional(),
  totalSubscribers: z.number().optional(),
  uniqueSubscribers: z.number().optional(),
  folderId: z.number().optional(),
  dynamicList: z.boolean().optional(),
  createdAt: z.string().optional(),
  modifiedAt: z.string().optional(),
});
export type GetContactListOutput = z.infer<typeof GetContactListOutputSchema>;

export type GetContactListActionStruct = ActionStruct<
  'get-contact-list',
  GetContactListInput,
  GetContactListOutput
>;
export const GetContactListActionSpec: ActionSpec<GetContactListActionStruct> = {
  id: 'get-contact-list',
  inputSchema: GetContactListInputSchema,
  outputSchema: GetContactListOutputSchema,
};
